/**
 * Linear interpolation between two Traccar-shape positions.
 * Shared by the historical replay engine and the live-map animation engine.
 *
 * @param {{ latitude: number, longitude: number, speed?: number, course?: number, fixTime?: string }} a
 * @param {{ latitude: number, longitude: number, speed?: number, course?: number, fixTime?: string }} b
 * @param {number} t  Normalised progress, clamped to [0, 1].
 * @returns {{ latitude: number, longitude: number, speed: number, course: number, fixTime: string }}
 */
export function lerpPosition(a, b, t) {
  const clamped = t < 0 ? 0 : t > 1 ? 1 : t;
  // Course is NOT interpolated: averaging two compass headings across the
  // 0/360 seam is a footgun (359 + 1 should be 0, not 180), and the marker
  // points "where the device is going" so b.course is the right answer.
  const aTime = a.fixTime ? new Date(a.fixTime).getTime() : 0;
  const bTime = b.fixTime ? new Date(b.fixTime).getTime() : 0;
  return {
    latitude: a.latitude + (b.latitude - a.latitude) * clamped,
    longitude: a.longitude + (b.longitude - a.longitude) * clamped,
    speed: (a.speed ?? 0) + ((b.speed ?? 0) - (a.speed ?? 0)) * clamped,
    course: b.course ?? a.course ?? 0,
    fixTime: new Date(aTime + (bTime - aTime) * clamped).toISOString(),
  };
}
